(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/shared-components/products/products.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/shared-components/products/products.js');
"use strict";


const {
  CardList,
  CardImageList
} = svs.tickets_giftshop.products.components;
const Products = _ref => {
  let {
    products = [],
    isImageOnly
  } = _ref;
  if (!products.length) return null;
  return React.createElement("div", {
    className: "tg-products col-sm-12 col-lg-8"
  }, isImageOnly ? React.createElement(CardImageList, {
    products: products
  }) : React.createElement(CardList, {
    products: products
  }));
};
svs.tickets_giftshop.products.Products = Products;

 })(window);